import { defineComponent as _defineComponent } from 'vue'
import { AbTitle, AbDescription, AbIcon } from '../../../ui';
import { CdnImg } from '@webplatform/cdn-image';
import { computed } from 'vue-demi';
import { type AbIcon as AbIconType } from '../../../../types';
import { LOCAL_AB_ICON_NAMES } from '../../../../components/ui/AbIcon/constants';

interface Props {
  icon?: string | null;
  title?: string | null;
  description?: string | null;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureSectionBenefitsItem',
  props: {
    icon: null,
    title: null,
    description: null
  },
  setup(__props: any) {

const props = __props as {
  icon?: string | null;
  title?: string | null;
  description?: string | null;
};



const isAbIcon = computed(
  () => props.icon && LOCAL_AB_ICON_NAMES.includes(props.icon),
);

const getAbIcon = (icon: string) => icon as AbIconType;

return { __sfc: true,props, isAbIcon, getAbIcon, AbTitle, AbDescription, AbIcon, CdnImg }
}

})